'use client';

import { type ReactNode, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import type { VariantType } from '../../../types/variant';
import styles from './ModalBase.module.scss';

/**
 * goodsmilekujiにてデザイン・機能に違いあり
 */
export type ModalBaseProps = {
  isOpen: boolean;
  onClose: VoidFunction;
  children?: ReactNode;
  textColor?: string;
  bgColor?: string;
  showCloseButton?: boolean;
};

function ModalBase({
  isOpen,
  onClose,
  children,
  textColor = 'black',
  bgColor = 'white',
  showCloseButton = true,
}: ModalBaseProps) {
  const currentStyles = styles;

  const generateStyle = ({
    textColor,
    bgColor,
  }: Pick<ModalBaseProps, 'textColor' | 'bgColor'>): React.CSSProperties => {
    if (bgColor === 'transparent') {
      return {
        backgroundColor: 'transparent',
      };
    }
    return {
      backgroundColor: `var(--color-${bgColor})`,
      color: `var(--color-${textColor})`,
    };
  };

  // warning対策
  const nodeRef = useRef(null);

  return (
    <CSSTransition in={isOpen} timeout={100} unmountOnExit classNames={currentStyles} nodeRef={nodeRef}>
      <div className={currentStyles.modalMask} ref={nodeRef}>
        <section className={currentStyles.modalContainer}>
          {showCloseButton && <button type='button' className={currentStyles.modalClose} onClick={() => onClose()} />}
          <div className={currentStyles.modalBody} style={generateStyle({ textColor, bgColor })}>
            {children}
          </div>
        </section>
      </div>
    </CSSTransition>
  );
}

export default ModalBase;
